<template>
  <div class="banner">
    <div class="banner-img">
      <img src="../../assets/img/pc/banner/banner.png" alt /> 
    </div> 
  </div>
</template>

<script>
export default {
  name: "banner",
  data() {
    return { 
    };
  },
  created() {
    // if (window.location.host == "sxdc.chineseall.cn") {
    //   this.wenziImg = require("../../assets/img/pc/zhutid.png");
    // } else {
    //   this.wenziImg = require("../../assets/img/pc/zhuti.png");
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
//  .banner::after{
//       content: "2023.04.23";
//       width: auto; 
//       bottom: 0.16rem;
//       left: 0.22rem;
//       position: absolute;  
//       display: inline-block;
//       z-index: 10;
//       font-size: 0.7rem;
//       color: #fff; 
//       font-family:'fangsong', 'Source Han Serif SC';
//       font-weight: bold;
//   }
.banner {
  width: 100%;
  height: 12.56rem; 
  position: relative;
  text-align: center;
  padding: 0;

  .banner-img {
    width: auto;
    height: auto;
    display: block;
    // position: absolute;
    // top: 0;
    // left: 0;
    img {
      width: 100%;
      height: auto;
    }
  }
  .banner-text {
    width: 13.78rem;
    height: auto;
    position: absolute;
    top: 2rem;
    left: 50%;
    transform: translateX(-50%);
    .wenzi {
      width: 100%;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    
  }
}
</style>
